import type { TableState } from "../types";
import { postRequestHandler } from "./common/post_request";
import { submitFormHandler } from "./common/submit_form";
import { executorHandler } from "./peers/executor";
import { executorWithPolicyHandler } from "./peers/executor_with_policy";

export type HandlerSource = "bulk_action" | "row_action" | "extra_button" | "change_form";

export type HandlerContext = {
  source: HandlerSource;
  actionName: string;
  selectedRows: Record<string, any>[];
  optionValues: Record<string, string>;
  config?: Record<string, any>;
  tableState?: TableState;
  selectAcross?: boolean;
};

export type HandlerFn = (ctx: HandlerContext) => void | Promise<void>;

const actionHandlers: Record<string, HandlerFn> = {
  post_request: postRequestHandler,
  submit_form: submitFormHandler,
  executor: executorHandler,
  executor_with_policy: executorWithPolicyHandler,
};

export function getHandler(name: string): HandlerFn {
  return actionHandlers[name] ?? actionHandlers.submit_form;
}
